export const fr_FR = {
  translation: {
    add_to_cart: "Ajouter l'article au panier",
    save: "Enregistrer",
    load: "Charger l'article",
    title: "Configuration",
    type_key: "Clé de type",
    start: "Démarrer",
    generate_document: "Créer une fiche technique",
    sap_button: "Créer un article dans SAP",
    cad_button: "Créer des données CAO",
    reset_configuration: "Réinitialiser la configuration",
    show_additional_information: "Afficher des informations supplémentaires",
    sap_title: "SAP",
    close_configuration_button: "Fermer",
    no_results_found: "Aucun résultat trouvé",
    load_configuration_dialog: {
      title: "Charger la configuration – Définir les paramètres de recherche",
      cancel: "Annuler",
      search: "Rechercher",
      start_date: "Date de création de",
      end_date: "à",
      guid: "GUID",
      material_number: "Numéro de matériel",
      order_code: "Code de commande",
      creator: "Créateur",
      description: "Description",
      info_artikel: "Info-article",
      short_text: "Texte court",
      version: "Version",
      status: "Statut",
      update_user: "Mis à jour par",
      createdDate: "Date de création",
      saved_records: "Enregistrements sauvegardés",
      back: "Retour",
      open: "Ouvrir",
      rows_per_page: "Lignes par page :",
    },
    error: {
      ERROR_LOAD_DATA_ERROR:
        "(CHARGEMENT) échoué (données incorrectes ou incomplètes)",
      ERROR_SAVE_DATA_ERROR:
        "(ENREGISTREMENT) échoué (données incorrectes ou incomplètes)",
      ERROR_LOAD_ID: "ID à charger introuvable",
      ERROR_LOAD_ID_CONFIG:
        "Erreur du configurateur lors du chargement d'un projet",
      ERROR_LOADSTART_CONFIG: "Erreur du configurateur au démarrage",
      ERROR_MISSING_VALUES:
        "Message d'erreur général si la validation des données frontend échoue",
      ERROR_COOKIE_SERVICE_INITIAL:
        "Échec de l'initialisation du service de cookies",
      ERROR_COOKIE_GENERAL: "Erreur dans le service de cookies",
      ERROR_TOKEN_NOT_FOUND: "Jeton non trouvé",
      ERROR_ID_BLOCKED:
        "L'article est en cours de modification, changements impossibles",
      ERROR_DB_SAVE:
        "Erreur lors de l'enregistrement des données dans la base de données",
      ERROR_LOAD_VALID:
        "Échec du chargement de la configuration, données invalides",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "ID introuvable, vérification SAP échouée",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Aucun numéro de matériel trouvé pour l'ID issu de l'ID boutique",
      ERROR_DELETE_CONFIGURATION:
        "Erreur lors de la suppression de la configuration",
      ERROR_DEFINITION_SECRET_JWT: "Définition JWT manquante",
      ERROR_PATH_NOT_DEFINED: "Chemin non défini",
      ERROR_BACKLINK_URL: "URL de retour non définie",
      ERROR_POSITIONDATA_EMPTY: "Les données de position sont vides",
      ERROR_SHOP_ID: "ID de boutique introuvable",
      ERROR_CADBOXDATA_EMPTY: "Aucune donnée de boîte CAD trouvée",
      ERROR_NONE_LOAD_ID_FOUND: "Aucun ID à charger trouvé",
      ERROR_NONE_ACCEPTABLE_ID: "Aucun ID acceptable trouvé",
    },
    sap: {
      create_error: "Erreur lors de la création",
      create_success: "Créé avec succès",
    },
    button: {
      save: "Enregistrer",
      cancel: "Annuler",
    },
  },
};

export default fr_FR;
